export default "__VITE_ASSET__Bk5UxLI2__"